import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { api } from '../helpers/utils';

const VibeVenueDetails = () => {
  const [venueDetails, setVenueDetails] = useState(null);
  const [bookedUsers, setBookedUsers] = useState([]);

  const venueId = new URLSearchParams(window.location.search).get('venueId');
  const lat = new URLSearchParams(window.location.search).get('lat');
  const long = new URLSearchParams(window.location.search).get('long');

  useEffect(() => {
    const fetchVenueDetails = async () => {
      try {
        const res = await api.post('/get-venue-details', {
          venueId,
          latLong: { latitude: lat, longitude: long },
        });
        if (res.data.status === 100) {
          setVenueDetails(res.data.venueDetails);
        }
      } catch (err) {
        console.error('Failed to fetch venue details', err);
      }
    };

    if (venueId) fetchVenueDetails();
  }, [venueId]);

  useEffect(() => {
    const fetchBookingDetails = async () => {
      try {
        const res = await api.post('/get-vibe-booking-details', {
          venueId,
          userId: '123',
        });

        if (res.data.status === 100) {
          setBookedUsers(res.data.bookedUserDetails);
        }
      } catch (e) {
        console.error('Error fetching booking data', e);
      }
    };

    if (venueId) fetchBookingDetails();
  }, [venueId]);

  if (!venueDetails) return null;

  return (
    <div style={styles.container}>
      <img
        src={venueDetails.images?.[0] || ''}
        alt="Venue"
        style={styles.image}
      />

      <h2 style={styles.title}>{venueDetails.vibeName}</h2>
      <p style={styles.subtitle}>{venueDetails.awayFromYou} km away</p>
      <p style={styles.address}>{venueDetails.address}</p>

      <div style={styles.priceTag}>₹ {venueDetails.priceText}</div>

      <div style={styles.buttonRow}>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${venueDetails.addressQuery}`}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.actionButton}
        >
          📍 Directions
        </a>

        {!venueDetails.isEvent && (
          <>
            <a href={`tel:${venueDetails.mobile}`} style={styles.actionButton}>
              📞 Call Now
            </a>
            <a href={`https://destinyapp.in/vibe-venue/${venueId}`} style={styles.actionButton}>
              📤 Share
            </a>
          </>
        )}
      </div>

      <p style={styles.description}>{venueDetails.description}</p>

      {venueDetails.tags && !venueDetails.isEvent && (
        <div style={styles.tagRow}>
          {venueDetails.tags.map((tag, index) => (
            <span key={index} style={styles.tag}>{tag}</span>
          ))}
        </div>
      )}

      {venueDetails.offerText && (
        <div style={styles.offerCard}>
          <h4 style={styles.offerHeading}>Exclusive Deal</h4>
          <p style={styles.offerText}>{venueDetails.offerText}</p>
          <p style={styles.offerSub}>{venueDetails.offerSubText}</p>
        </div>
      )}

{bookedUsers.length > 0 && (
  <div style={{ marginTop: 20 }}>
    <h3 style={{ color: '#fff', marginBottom: 10 }}>People who booked:</h3>
    <ul style={{ padding: 0, listStyle: 'none' }}>
      {bookedUsers.map(user => (
        <li
          key={user._id}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: 10,
          }}
        >
          <img
            src={user.userProfilePic || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.userName || 'User')}
            alt="avatar"
            style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              objectFit: 'cover',
              border: '1px solid #444',
            }}
          />
          <span style={{ color: '#ccc', fontSize: 15 }}>
            {user.userName || 'Unnamed User'}
          </span>
        </li>
      ))}
    </ul>
  </div>
)}


      <br /><br /><br />
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#000',
    color: '#fff',
    padding: 10,
    fontFamily: 'Arial, sans-serif',
    maxWidth: 600,
    height: '100vh',
    overflowY: 'auto',
  },
  image: {
    width: '100%',
    borderRadius: 8,
    height: 220,
    objectFit: 'cover',
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    marginTop: 12,
    color: '#fff',
  },
  subtitle: {
    color: '#bbb',
    fontSize: 14,
    marginTop: 4,
  },
  address: {
    color: '#bbb',
    fontSize: 14,
    marginTop: 4,
  },
  priceTag: {
    color: '#FFD700',
    fontWeight: 'bold',
    marginTop: 8,
    fontSize: 16,
  },
  buttonRow: {
    display: 'flex',
    gap: 10,
    marginTop: 14,
    flexWrap: 'wrap',
  },
  actionButton: {
    backgroundColor: '#1a1a1a',
    padding: '10px 12px',
    borderRadius: 8,
    color: '#fff',
    textDecoration: 'none',
    border: '1px solid #333',
    fontSize: 14,
  },
  description: {
    marginTop: 20,
    lineHeight: 1.6,
    fontSize: 14,
    color: '#ccc',
  },
  tagRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 16,
  },
  tag: {
    border: '1px solid #aaa',
    borderRadius: 20,
    padding: '4px 12px',
    fontSize: 12,
    color: '#ccc',
  },
  offerCard: {
    marginTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    backgroundColor: '#111',
    borderRadius: 10,
    border: '1px solid #333',
  },
  offerHeading: {
    color: '#fff',
    fontSize: 16,
    marginBottom: 6,
  },
  offerText: {
    color: '#00b7ff',
    fontWeight: 'bold',
    fontSize: 16,
  },
  offerSub: {
    color: '#ccc',
    fontSize: 13,
    marginTop: 4,
  },
};

export default VibeVenueDetails;
